// Small shared presentational helpers.

// Renders a display title where odd-index parts are Bodoni italic accents.
export function Title({ parts, className = "", tag: Tag = "h2" }) {
  return (
    <Tag className={`display ${className}`}>
      {parts.map((p, i) =>
        i % 2 === 1 ? (
          <span key={i} className="accent">
            {p}
          </span>
        ) : (
          <span key={i}>{p}</span>
        )
      )}
    </Tag>
  );
}

export function Kicker({ children, withDash = false, className = "" }) {
  return (
    <span className={`kicker ${className}`}>
      {children}
      {withDash && <i className="dash" />}
    </span>
  );
}
